import { CertificateAuthority } from "@hydrantid/acm-client";
import { createFeatureSelector, MemoizedSelector } from "@ngrx/store";

export interface AppState {
    certificateAuthorities: CertificateAuthority[];
}

export const certificateAuthorities: MemoizedSelector<AppState, CertificateAuthority[]> =
    createFeatureSelector("certificateAuthorities");
